import clsx from 'clsx';
import { useToasts } from '../lib/hooks';

export function Toaster() {
  const toasts = useToasts();
  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={clsx(
            'pointer-events-auto rounded-md border px-3 py-2 text-sm shadow-md min-w-[200px]',
            t.tone === 'success' &&
              'bg-emerald-50 border-emerald-300 text-emerald-900 dark:bg-emerald-950 dark:border-emerald-800 dark:text-emerald-100',
            t.tone === 'error' &&
              'bg-rose-50 border-rose-300 text-rose-900 dark:bg-rose-950 dark:border-rose-800 dark:text-rose-100',
            t.tone === 'info' &&
              'bg-zinc-50 border-zinc-300 text-zinc-900 dark:bg-zinc-900 dark:border-zinc-700 dark:text-zinc-100',
          )}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
